import React, { useRef, useEffect } from 'react'
import styles from './SidebarContent.module.css'
import IconProgress from '../../../../assets/icons/IconProgress'
import IconReviewWords from '../../../../assets/icons/IconReviewWords'
import IconReviewGrammar from '../../../../assets/icons/IconReviewGrammar'
import IconHome from '../../../../assets/icons/IconHome'
import { useHistory } from 'react-router-dom'


const ButtonRow = ({ Icon, title, onClick, selected }) => {
    return (
        <div
            className={styles.buttonRow}
            style={selected ? { backgroundColor: 'rgb(228, 247, 228)' } : {}}
            onClick={onClick}>
            <Icon size={20} />
            <p className={styles.buttonTitle}>{title}</p>
        </div>
    )
}

const countWordsToReview = (words) => {
    if (words) {
        const currTime = new Date().getTime()
        let count = 0;
        for (let wordKey in words) {
            if (words[wordKey].dateToReview.seconds * 1000 < currTime)
                count += 1
        }
        return count
    }
    else return 0;
}

const SidebarContent = ({
    onLogoutClick,
    displayName,
    userType,
    onProgressClick,
    onHomeClick,
    onBecomePremiumClick,
    currScreen,
    words,
}) => {

    const history = useHistory();
    const wordsToReview = useRef(countWordsToReview(words))

    //console.log(wordsToReview.current);

    /* useEffect(() => {
        console.log({words});
        words.filter(w => true)
    }, [words]) */

    return (
        <div className={styles.container}>
            <div className={styles.upperContainer}>
                <p className={styles.title}>Shepha</p>
                <p className={styles.name}>{displayName}</p>
                <p className={styles.userStatus}>{userType}</p>
                <div className={styles.buttonsContainer}>
                    <ButtonRow
                        selected={currScreen === 0}
                        onClick={onHomeClick}
                        Icon={IconHome}
                        title={'Home'} />
                    <ButtonRow
                        selected={currScreen === 1}
                        onClick={onProgressClick}
                        Icon={IconProgress}
                        title={'Progress'} />
                    <ButtonRow
                        Icon={IconReviewWords}
                        onClick={() => history.push('/course', {
                            page: 'REVIEW',
                        })}
                        title={wordsToReview.current < 4 ? 'Review Words' : 'Review Words (' + wordsToReview.current + ')'} />
                    {/* <ButtonRow
                        Icon={IconReviewGrammar}
                        title={'Review Grammar'} /> */}
                </div>
            </div>
            <div className={styles.bottomContainer}>
                <button
                    className={styles.becomePremium} 
                    onClick={onBecomePremiumClick}>Become Premium</button>
                <button
                    onClick={onLogoutClick}
                    className={styles.logout}>Log out</button>
            </div>
        </div>
    )
}

export default SidebarContent
